"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRedirect = exports.acquireToken = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const authentication_1 = require("@/constants/authentication");
const msalInstance_1 = require("@/commons/msalInstance");
const localStorage_1 = require("@/utilities/localStorage");
function handleAcquireTokenRedirect(silentTokenRequest) {
    return msalInstance_1.msalInstance.acquireTokenRedirect(silentTokenRequest);
}
async function acquireToken(account) {
    const silentTokenRequest = {
        scopes: authentication_1.IFF_TOKEN_SILENT_REQUEST.scopes,
        account,
    };
    try {
        const response = await msalInstance_1.msalInstance.acquireTokenSilent(silentTokenRequest);
        if (response.accessToken)
            (0, localStorage_1.setItemInLocalStorage)("accessToken", response.accessToken);
        if (response.expiresOn)
            (0, localStorage_1.setItemInLocalStorage)("expiresOn", response.expiresOn);
        return {
            accessToken: response?.accessToken || undefined,
            expiresOn: response?.expiresOn || undefined,
        };
    }
    catch (error) {
        if (error instanceof msal_browser_1.InteractionRequiredAuthError) {
            handleAcquireTokenRedirect(silentTokenRequest);
        }
        return error;
    }
}
exports.acquireToken = acquireToken;
async function loginRedirect(instance) {
    try {
        await instance.loginRedirect(authentication_1.IFF_LOGIN_REQUEST);
    }
    catch (e) {
        await instance.loginPopup(authentication_1.IFF_LOGIN_REQUEST);
    }
}
exports.loginRedirect = loginRedirect;
